





















import Vue from "vue";
import Separator from "@/components/Separator.vue";
import { mapGetters } from "vuex";
import LandingCard from "@/components/LandingCard.vue";

interface Data {
  hasOtherLoginProviders: boolean;
}

export default Vue.extend({
  name: "LoginPage",
  components: {
    LandingCard,
    Separator,
  },
  data(): Data {
    return {
      hasOtherLoginProviders: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["getAuthDisplayName", "getUserCustomers"]),
  },
});
